var map = {
	"./4medical.png": "32cf",
	"./amboss.png": "81d6",
	"./amboss_white.png": "92a9",
	"./biodigital.jpg": "8d70",
	"./ditki.png": "0d5c",
	"./ditki_white.png": "0a12",
	"./edu.png": "dde8",
	"./oup.png": "6f6e",
	"./proQuest.png": "1c46",
	"./theme-candena_logo-grey.png": "f548",
	"./theme-candena_logo.png": "82ba",
	"./theme-edu_logo-grey.png": "ef23",
	"./theme-edu_logo.png": "94c6",
	"./thieme.png": "60e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf0c";